export default "__VITE_ASSET__trENc$1c__"